const SlideFade = {
  baseStyle: {
    width: "100%",
  },
};

export default SlideFade;
